export interface SidebarItem {
  title: string;
  icon: string;
  route?: string;
  action?: () => void;
}
